// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';
import * as coreSelectors from '../core/selectors';

import * as Formatters from '../ui/Formatters';
import * as MessageFormat from './MessageFormat';
import * as ServiceIcons from './Icons';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchieveIcon from '@material-ui/icons/Unarchive';

import AccountCircle from '@material-ui/icons/AccountCircle';

const styles = theme => ({
  ...MessageFormat.styles(theme),
});

/*
 * Format for an SMS
 */
class SmsFormat extends Component {

  constructor(props){
    super(props);
    this.gridRef = React.createRef()
  }

  componentDidMount(){
    const gridElement = this.gridRef.current;
    gridElement.scrollTop = gridElement.scrollHeight;
  }

  render() {
    /* eslint-disable */
    const { classes, message, user, messages, markMessageRead, unmarkMessageRead, archiveMessage, unarchiveMessage, setActivityDetailOpen, toggleFollowup  } = this.props;

    let phoneNumbers = [];
    user?.patchNumbers?.forEach(number => {
      phoneNumbers.push(number.phoneNumber);
    })

    let allSms = message?.messages || [];

    let sender;
    if (Boolean(message.sendingUser)) {
      sender=message.sendingUser;
    } else {
      sender=Formatters.formatPhoneNumber(message.ani);
    }
    
    return (
      <div className={classes.formatTop}>
        <div style={{textAlign: 'center', fontSize: 15, fontFamily: 'Sofia-bold',}}>
          {sender}
        </div>
        <div className={classes.taken}>
          {Formatters.formatDateTime(message.taken)}
        </div>
        <div className={classes.messageSender}>
          {`Your Caller ID: ${Formatters.formatPhoneNumber(message.dnis)}`}
        </div>

        <MuiCore.Grid item>
            <MuiCore.Grid container style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 10}}>
              <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                  if(message.messageRead){
                    unmarkMessageRead(message.messageId)
                  }else{
                    markMessageRead(message.messageId)
                  }
                  setActivityDetailOpen(false);
                }}>
                  <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50, marginLeft: 10}}>
                    <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                      <MuiCore.SvgIcon xmlns="http://www.w3.org/2000/svg" width="31.5" height="21" viewBox="0 0 31.5 21" style={{color: '#122457', marginTop: 13}}>
                        <path d="M.6.99V16.571L11.439,9.345ZM16.294,13.3l-3.726-2.823L.6,18.49V21.2H32.1V18.49L19.907,10.361Zm15.694,3.387V1.1L21.149,9.458ZM16.294,11.265,30.52.2H2.068Z" transform="translate(-0.6 -0.2)"/>
                      </MuiCore.SvgIcon>
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                  <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                    {'Mark unread'}
                  </MuiCore.Typography>
                </MuiCore.Grid>
                <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                  if(message.messageArchived){
                    unarchiveMessage(message.messageId);
                  }else {
                    archiveMessage(message.messageId);
                  }
                  setActivityDetailOpen(false);
                  }}>
                  <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50}}>
                    <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                      {message.messageArchived ? <UnarchieveIcon fontSize='medium' style={{marginTop: 13, color:'#122457'}}/> : <ArchiveIcon fontSize='medium' style={{marginTop: 13, color:'#122457'}}/>}
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                  <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                  {message.messageArchived ? 'Unarchive': 'Archive'}
                  </MuiCore.Typography>
                </MuiCore.Grid>
                <MuiCore.Grid item style={{textAlign: 'center', margin: 10, cursor: 'pointer'}} onClick={() => {
                  toggleFollowup(message, true)
                }}>
                  <MuiCore.Grid item style={{backgroundColor: 'rgba(0,0,0,0.1)', borderRadius: 40, height: 50, width: 50}}>
                    <MuiCore.Grid item style={{verticalAlign: 'middle', height: '100%'}}>
                      <ServiceIcons.FollowupIcon style={{color: '#122457', marginTop: 13}} followup={message.followup}/>
                    </MuiCore.Grid>
                  </MuiCore.Grid>
                  <MuiCore.Typography style={{fontFamily: 'Sofia-bold', fontSize: 11, marginTop: 10}}>
                    Follow Up
                  </MuiCore.Typography>
                </MuiCore.Grid>
              </MuiCore.Grid>
          </MuiCore.Grid>
        <MuiCore.Divider/>


        <MuiCore.Grid style={{overflow: 'auto', maxHeight: 350}} ref={this.gridRef}>
          {message.messageType === 'SMS' ? <div style={{marginTop: 10, display: 'flex', flexDirection: 'column', height: 350, marginBottom: 10}}>
            {allSms.map((sms) => (
              <div style={sms.sendingUserId === undefined ? {display: 'flex', flexDirection: 'row'} : {}}>
                {sms.sendingUserId === undefined && <AccountCircle fontSize='small' style={{ marginBottom: 0, marginTop: 'auto', color: '#EF9CA1' }}/>}
                <div className={sms.sendingUserId ? classes.sentMessageData : classes.receivedMessageData}>
                  {sms.textContent ? sms.textContent : <img src={JSON.parse(sms.formContent)?.fields[0]?.value} style={{width: '100%', height: 'auto', display: 'block'}} onDoubleClick={() => {
                    window.open(JSON.parse(sms.formContent)?.fields[0]?.value);
                  }}/>}
                </div>
              </div>
            ))}
          </div> : 
          <div style={{marginTop: 10, display: 'flex', flexDirection: 'column', height: 350, marginBottom: 10}}>
          {allSms.map((sms) => (
            <div style={sms.author === message.visitorFullName ? {display: 'flex', flexDirection: 'row'} : {}}>
              {sms.author === message.visitorFullName && <AccountCircle fontSize='small' style={{ marginBottom: 0, marginTop: 'auto', color: '#EF9CA1' }}/>}
              <div className={sms.author === message.visitorFullName ? classes.receivedMessageData : classes.sentMessageData}>
                {sms.message}
              </div>
            </div>
          ))}
        </div>}
        </MuiCore.Grid>

        <MessageFormat.MessageStatus
          message={message}
          sectionHeaderClass={classes.sectionHeader}
          fieldLabelClass={classes.fieldLabel}
          fieldDataClass={classes.fieldData}/>       
        
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    message : serviceSelectors.getMessage(state),
    messages : serviceSelectors.getMessages(state),
    user: coreSelectors.getUser(state)
  });
};

const mapDispatchToProps = {
  archiveMessage : serviceActions.archiveMessage,
  unarchiveMessage : serviceActions.unarchiveMessage,
  markMessageRead : serviceActions.markMessageRead,
  unmarkMessageRead : serviceActions.unmarkMessageRead,
  setActivityDetailOpen : serviceActions.setActivityDetailOpen,
  toggleFollowup : serviceActions.toggleFollowup,
};

export default connect(mapStateToProps,
                       mapDispatchToProps)(withStyles(styles)(SmsFormat));

